import { render, staticRenderFns } from "./media-owl-carousel.vue?vue&type=template&id=5dd350d5"
import script from "./media-owl-carousel.vue?vue&type=script&lang=js"
export * from "./media-owl-carousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports